"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input(props) {
    (0, _classCallCheck3.default)(this, Input);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call(this, props));

    _this.state = {
      value: ""
    };
    return _this;
  }

  (0, _createClass3.default)(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          readOnly = _props.readOnly,
          id = _props.id,
          type = _props.type,
          fieldProps = _props.fieldProps,
          small = _props.small,
          handleBlur = _props.handleBlur,
          disabled = _props.disabled,
          max = _props.max;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group";
      if (hasError) {
        formGroupClasses += " has-error";
      }
      if (small) {
        formGroupClasses += " form-group-small";
      }

      var props = (0, _extends3.default)({
        id: id,
        type: type,
        disabled: disabled
      }, max && { maxLength: max }, fieldProps);

      if (handleBlur) {
        props.onBlur = handleBlur;
      }

      if (readOnly) {
        return _react2.default.createElement(
          "div",
          { className: formGroupClasses },
          this.renderLabel(),
          _react2.default.createElement("input", (0, _extends3.default)({ readOnly: true, autoComplete: "none" }, props)),
          _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps }),
          this.props.children
        );
      }

      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        this.renderLabel(),
        _react2.default.createElement("input", (0, _extends3.default)({}, props, max && {
          value: this.state.value,
          onChange: function onChange(e) {
            _this2.setState({ value: e.target.value });
          }
        }, {
          autoComplete: "none"
        })),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps }),
        max && _react2.default.createElement(
          "div",
          null,
          this.state.value.length,
          " / ",
          max
        ),
        this.props.children
      );
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _props2 = this.props,
          id = _props2.id,
          label = _props2.label,
          subLabel = _props2.subLabel,
          type = _props2.type;


      if (type === "hidden") {
        return null;
      }

      if (subLabel) {
        return _react2.default.createElement(
          "label",
          { htmlFor: id },
          label,
          ": ",
          _react2.default.createElement(
            "span",
            { className: "small" },
            subLabel
          )
        );
      }
      return _react2.default.createElement(
        "label",
        { htmlFor: id },
        label,
        ":"
      );
    }
  }]);
  return Input;
}(_react.Component), _class.propTypes = {
  id: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string,
  small: _react.PropTypes.bool,
  subLabel: _react.PropTypes.string,
  fieldProps: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.object,
  handleBlur: _react.PropTypes.func,
  readOnly: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  max: _react.PropTypes.number
}, _class.defaultProps = {
  readOnly: false,
  disabled: false
}, _temp);
exports.default = Input;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/Input.js
 ** module id = 34
 ** module chunks = 0
 **/